import TimeList from './TimeList';
import { DayOfWeek, NearByV4Response, OfficeSearchApiResponse, SlotsSearchResponseV4, TimeOfDay } from '@src/lib/__generated/api';
import { trimTimeZoneOffset } from '@src/utils/trimTimeZoneOffset';
export const groupSlotsByDate = (slots: SlotsSearchResponseV4[]) => {
  if (!slots) return null;
  return slots.reduce<Record<string, SlotsSearchResponseV4[]>>((groups, slot) => {
    const date = slot.time?.slice(0, 10) ?? '';
    if (!groups[date]) {
      groups[date] = [];
    }
    groups[date].push(slot);
    return groups;
  }, {});
};
export const renderSlots = (slots: Record<string, SlotsSearchResponseV4[]>, days: number, facility: OfficeSearchApiResponse, filters: Filters) => {
  return Object.entries(slots ?? []).slice(0, days).map(([key, value]) => {
    return <TimeList key={key} slots={value} location={facility} filters={filters} />;
  });
};
interface IFilterBuilder {
  data: SlotsSearchResponseV4[];
  addData: (data: SlotsSearchResponseV4[]) => IFilterBuilder;
  filterByTimeOfDay: (timeFilter: string) => IFilterBuilder;
  filterByDayOfWeek: (dayOfWeekFilter: string[]) => IFilterBuilder;
  filterByDaysFromToday: (daysFromToday: number | null) => IFilterBuilder;
  filterByDaysAfterDate: (date: Date) => IFilterBuilder;
  build: () => SlotsSearchResponseV4[];
}
export const FilterBuilder: IFilterBuilder = {
  data: [],
  addData(data: SlotsSearchResponseV4[]) {
    this.data = [...data];
    return this;
  },
  filterByTimeOfDay(timeFilter: string) {
    if (timeFilter) {
      const twelveNoon = 12;
      this.data = this.data.filter(({
        time
      }) => {
        const hour = new Date(trimTimeZoneOffset(time) ?? '').getHours();
        if (timeFilter === TimeOfDay.AM) {
          return hour < twelveNoon;
        } else if (timeFilter === TimeOfDay.PM) {
          return hour >= twelveNoon;
        }
      });
    }
    return this;
  },
  filterByDayOfWeek(dayOfWeekFilter: string[] | null) {
    if (dayOfWeekFilter && dayOfWeekFilter.length > 0) {
      this.data = this.data.filter(({
        time
      }) => {
        return dayOfWeekFilter.includes(daysOfWeek[new Date(time ?? '').getDay()]);
      });
    }
    return this;
  },
  filterByDaysFromToday(daysFromToday: number | null) {
    if (daysFromToday) {
      const today = new Date();
      const futureDate = new Date(today.setDate(today.getDate() + daysFromToday)).toISOString().slice(0, 10);
      this.data = this.data.filter(({
        time
      }) => {
        return time && time < futureDate;
      });
    }
    return this;
  },
  filterByDaysAfterDate(date: Date) {
    if (Date.parse(date.toString())) {
      this.data = this.data.filter(({
        time
      }) => {
        return time && time >= new Date(date.toDateString()).toISOString().slice(0, 10);
      });
    }
    return this;
  },
  build() {
    return this.data;
  }
};
export const getLead = (slots: SlotsSearchResponseV4[] | undefined, nearbySlots: NearByV4Response[] | undefined) => {
  if (slots?.length) {
    return {
      leadScore: slots[0].patientValue,
      leadTierNational: slots[0].nationalPatientTier,
      leadTierOffice: slots[0].patientTier
    };
  }
  const foundNearbySlot = nearbySlots?.find(nearbySlot => nearbySlot?.timeslots?.length);
  if (foundNearbySlot?.timeslots?.length) {
    return {
      leadScore: foundNearbySlot?.timeslots[0]?.patientValue,
      leadTierNational: foundNearbySlot?.timeslots[0]?.nationalPatientTier,
      leadTierOffice: foundNearbySlot?.timeslots[0]?.patientTier
    };
  }
  return null;
};
const daysOfWeek = [DayOfWeek.Sunday, DayOfWeek.Monday, DayOfWeek.Tuesday, DayOfWeek.Wednesday, DayOfWeek.Thursday, DayOfWeek.Friday, DayOfWeek.Saturday];
export type Filters = {
  timeOfDay: string;
  weekDays: string[];
};
export const SIXTY_DAYS = 60;
export type Lead = {
  leadScore: number | null | undefined;
  leadTierNational: number | null | undefined;
  leadTierOffice: number | null | undefined;
};